import { Formik, FormikHelpers } from 'formik';
import React from 'react';
import { useActions } from 'src/hooks/useActions';
import { IWorkLocation } from 'src/interfaces/personal-info';

import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

import { alphabetRegex } from 'src/utils/alphabetRegex';
import { FormInput } from 'pg-ui-library';
import {
  Container,
  FormInputContainer,
  FormRow,
  FormTitle,
  WorkLocationFormContainer,
  WorkLocation,
  SeparatorLineStraight,
  FormTitleItem,
  FormInputLabel,
} from './styles';
import { PersonalInfoForm } from '../..';

const WorkLocationForm: React.FC<PersonalInfoForm> = ({ personalInfo, isResident }) => {
  const { t } = useTranslation();

  const workLocationSchema = yup.object({
    location: yup
      .string()
      .matches(alphabetRegex, t('global.form.alphabet'))
      .required(t('global.form.required'))
      .min(2)
      .max(20),
    address: yup.string().required(t('global.form.required')).min(2).max(255),
  });
  const { patchPersonalInfo } = useActions();

  const onSubmit = (
    values: IWorkLocation,
    // eslint-disable-next-line no-unused-vars
    { setSubmitting }: FormikHelpers<IWorkLocation>
  ) => {
    patchPersonalInfo({
      ...personalInfo,
      workLocation: values,
    });
  };
  return (
    <>
      {/* <MainTitle>{t('personalInfo.workLocation.title')}</MainTitle> */}
      <Formik
        enableReinitialize
        initialValues={{
          location: isResident
            ? personalInfo?.residentLocation.location || ''
            : personalInfo?.workLocation.location || '',
          address: isResident ? personalInfo?.residentLocation.address || '' : personalInfo?.workLocation.address || '',
        }}
        validationSchema={workLocationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, errors }) => (
          <Container onSubmit={handleSubmit} style={{ boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '5px' }}>
            <WorkLocation>
              <FormTitle>
                <FormTitleItem>
                  {isResident ? t('personalInfo.residentLocation.title') : t('personalInfo.workLocation.title')}
                </FormTitleItem>
              </FormTitle>
              <SeparatorLineStraight />
              <FormRow>
                <WorkLocationFormContainer>
                  <FormInputContainer>
                    <FormInputLabel>{t('personalInfo.workLocation.location')}</FormInputLabel>
                    <FormInput
                      label=""
                      id="location"
                      name="location"
                      isRequired
                      hasError={!!errors.location}
                      style={{ width: '100%' }}
                    />
                  </FormInputContainer>
                  <FormInputContainer>
                    <FormInputLabel>{t('personalInfo.workLocation.address')}</FormInputLabel>
                    <FormInput
                      // disabled={!edit}
                      label=""
                      id="address"
                      name="address"
                      isRequired
                      hasError={!!errors.address}
                      style={{ width: '100%' }}
                    />
                  </FormInputContainer>
                </WorkLocationFormContainer>
              </FormRow>
            </WorkLocation>
          </Container>
        )}
      </Formik>
    </>
  );
};

export default WorkLocationForm;
